module.exports = __webpack_public_path__ + "img/cadre.9ff33e80.png";